import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, Component, useRef, useEffect, useState } from "react"
import apiResponse from "../../../../services/apiResponse"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap"

import moment from "moment"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { Link } from 'react-router-dom'

import Select from "react-select"
import YearSelect from '../../../../helpers/ui/YearSelect';
import Shimmer from "react-shimmer-effect";
import classnames from "classnames"

import TableComponent from './Components/TableComponent'
import TableSecondComponent from "./Components/TableSecondComponent"
import TablePreocessedComponent from "./Components/TablePreocessedComponent"
import IndexBloc from '../Index/Blocs/IndexBloc'

const reformatDate = (date) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const d = new Date(date);
    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
};

const PegawaiView = (props) => {
    const userdata = JSON.parse(localStorage.getItem('userdata'));
    const employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'))
    const peg_detail = !accessRole('approve') ? (userdata != null ? userdata : "") 
    : (employeeSeleted != null ? employeeSeleted : "")
    const currentRoleId = localStorage.getItem('currentRoleId') ? JSON.parse(localStorage.getItem('currentRoleId')) : {};

    const indexBloc = new IndexBloc()

    const [activeTab, setactiveTab] = useState("1")  
    const activeRef = useRef();
    const thirdRef = useRef();
    const [period, setPeriod] = useState()
    

    const secondaryRef = useRef();

    function toggle(tab) {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }
    const reloadInactiveRef = () => activeRef.current.setTokenAPI()

    const reloadSecondaryRef = () => secondaryRef.current.setTokenAPI()
    const reloadThirdeRef = () => thirdRef.current.setTokenAPI()

    useEffect(() => {
        if(currentRoleId != 1){
            toggle("2")
        }
        indexBloc.fetchDetail({ uuid: props.uuid })
        indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    setPeriod(result.data.response)
                    break;
                    default:
                        break;
                    }
                    console.log(result.data.response)
        })
        return () => {
            indexBloc.detailChannel?.unsubscribe()
        }
    }, [])

    return (
        <Fragment>
            <Container fluid>
                <Card>
                    <CardBody>
                        <CardTitle>Daftar Pegawai Hukuman Disiplin</CardTitle>
                        <CardSubtitle className="mb-3">
                            {/* Daftar Urut Kepangkatan */}
                        </CardSubtitle>
                        <hr/>
                        <div className="float-end">
                        {/* {
                            (accessRole('create')) ?
                                // <Link to={`?addpegawai&uuid=`+props.uuid}>
                                //     <Button color="primary">Tambah Pegawai</Button>
                                // </Link>
                            : null
                        } */}
                        {
                            userdata?.is_atasan == 1 && currentRoleId != 1 ?
                                <Link to={`?listatasan&uuid=`+props.uuid}>
                                    <Button color="primary">List Hukuman Disiplin Bawahan</Button>
                                </Link>
                            : null
                        }
                        </div>
                        <Row className="mb-3">
                            <Label className="col-md-2 col-form-label">Periode :</Label>
                            <Label className="col-md-6 col-form-label">{(period ? reformatDate(period?.punishment_periode_start_date) +' s/d ': '-')+(period ? reformatDate(period?.punishment_periode_end_date): '-')}</Label>
                        </Row>
                        {period?.punishment_periode_desc ?
                        <Row className="mb-3">
                            <Label className="col-md-2 col-form-label">Keterangan :</Label>
                            <Label className="col-md-6 col-form-label">{(period ? period?.punishment_periode_desc: '-')}</Label>
                        </Row>
                            :''
                        }
                        <hr/>
                        <Nav tabs>
                        {currentRoleId == 1 ?
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        active: activeTab === "1",
                                    })}
                                    onClick={() => {
                                        toggle("1")
                                    }}
                                >
                                    <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                    <span className="d-none d-sm-block">Data Rekomendasi</span>
                                </NavLink>
                            </NavItem>
                            :''
                        }
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                    active: activeTab === "2",
                                        })}
                                    onClick={() => {
                                        toggle("2")
                                    }}
                                >
                                    <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                    <span className="d-none d-sm-block">Belum Diproses</span>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                    active: activeTab === "3",
                                        })}
                                    onClick={() => {
                                        toggle("3")
                                    }}
                                >
                                    <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                    <span className="d-none d-sm-block">Data Diproses</span>
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab} className="p-3 text-muted">
                        {currentRoleId == 1 ?
                            <TabPane tabId="1">
                                <TableComponent ref={activeRef} handleProcessSuccess={reloadSecondaryRef} handleInactiveSuccess={reloadInactiveRef} handlethirdSuccess={reloadThirdeRef} uuid={props.uuid} isadmin={currentRoleId} />
                            </TabPane>
                            :''
                        }
                            <TabPane tabId="2">
                                <TableSecondComponent ref={secondaryRef} uuid={props.uuid} periodDate={period?.period_promotion_date} handleInactiveSuccess={reloadInactiveRef} employeeuuid={userdata.employee_uuid} isadmin={currentRoleId}/>
                            </TabPane>
                            <TabPane tabId="3">
                            <TablePreocessedComponent ref={thirdRef} uuid={props.uuid} periodDate={period?.period_promotion_date} handleInactiveSuccess={reloadThirdeRef} employeeuuid={userdata.employee_uuid} isadmin={currentRoleId}/>
                            </TabPane>
                        </TabContent>
                        <div>
                            <Link to='/kepegawaian/hukuman_disiplin.html'>
                                <Button color="danger"><i className="uil-backspace"></i> Kembali</Button>
                            </Link>
                        </div>
                    </CardBody>
                </Card>
            </Container>
        </Fragment>

    )
}

export default PegawaiView